import {requireProps, makeCnVariants} from '../../../../helpers'
import {Layout} from '../../../layout'
import {usePageContext} from '../../../page_layout/page_context'
import {BasicTableHeader} from '../header'
import {BasicTableSectionHeader} from '../section_header'
import {BasicTableBody} from '../body'
import {BasicTableProvider} from '../../context'

const headerInlineStyles = {zIndex: 3}

export const BasicTable = ({
	name,
	columns,
	data,
	defaultSortField,
	placeholderProps,
	virtual = data.length > 20,
	sectionHeader,
	height = 'full',
	hideHeaderOnEmpty = false,
	...contextProps
}) => {
	const {floating, headerHeight} = usePageContext()
	const fullHeight = height === 'full'
	const hideHeader = hideHeaderOnEmpty && data.length === 0
	const classNames = makeCnVariants('basic-table', fullHeight && 'full-height', height === 'content' && 'content-height')

	requireProps('BasicTable', {name, columns})

	contextProps = {
		name,
		columns,
		data,
		defaultSortField,
		placeholderProps,
		virtual,
		sectionHeader,
		hideHeader,
		...contextProps,
	}

	return (
		<BasicTableProvider {...contextProps}>
			<Layout className={classNames} width="full" direction="vertical" gap={0} borderRadius grow={fullHeight} background="white">
				<Layout
					direction="vertical"
					width="full"
					sticky={floating && `${headerHeight} - - -`}
					background="light-background"
					style={headerInlineStyles}
				>
					<BasicTableSectionHeader />
					<BasicTableHeader />
				</Layout>
				<BasicTableBody />
			</Layout>
		</BasicTableProvider>
	)
}
